import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import axios from 'axios';
import { toast } from 'react-toastify';

const Sidebar = () => {
    const location = useLocation();
    const {
        isSidebarOpen,
        toggleSidebar,
        isPaymentsOpen,
        togglePayments,
        isCategoryOpen,
        toggleCategory,
        isInventoryOpen,
        toggleInventory,
        isUserOpen,
        toggleUser,
        isClassOpen,
        toggleClass,
        isTeamOpen,
        toggleTeam,
        isActivityOpen,
        toggleActivity,
        isUserOpenMain,
        toggleUserMain
    } = useSidebar();

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const sidebarClass = isMobile ? (isSidebarOpen ? 'closed' : 'open') : (isSidebarOpen ? 'open' : 'closed');
    const sidebarRef = useRef(null);
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [categoryId, setCategoryId] = useState(null)

    const handleToggleSection = (toggleFn) => {
        if (sidebarRef.current) {
            sessionStorage.setItem('sidebarScrollPosition', sidebarRef.current.scrollTop);
        }
        toggleFn();
    };

    const handleLinkClick = (e) => {
        if (sidebarRef.current) {
            sessionStorage.setItem('sidebarScrollPosition', sidebarRef.current.scrollTop);
        }
    };


    useEffect(() => {
        const savedPosition = sessionStorage.getItem('sidebarScrollPosition');
        if (sidebarRef.current && savedPosition) {
            setTimeout(() => {
                sidebarRef.current.scrollTop = parseInt(savedPosition, 10);
            }, 50);
        }
    }, [location]);

    useEffect(() => {
        const saveScrollPosition = () => {
            if (sidebarRef.current) {
                sessionStorage.setItem('sidebarScrollPosition', sidebarRef.current.scrollTop);
            }
        };

        window.addEventListener('beforeunload', saveScrollPosition);
        return () => {
            saveScrollPosition();
            window.removeEventListener('beforeunload', saveScrollPosition);
        };
    }, []);

    const isActive = (path) => location.pathname === path;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    console.log(categoryId)
    return (
        <>
            <Header />
            <div className={`sidebar ${sidebarClass}`}>
                <div className="sidebar-list" ref={sidebarRef}>
                    <div className="side-bar-header">
                        <h1 className={isSidebarOpen ? '' : 'closed'}>100billion OMS</h1>
                    </div>
                    <div className="side-bar-nav">
                        <ul>
                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }} title={isSidebarOpen ? '' : 'CRM'}>
                                <div className="main-menu">
                                    <Link to="/" onClick={handleLinkClick} className={isActive('/') ? 'active-link' : ''}>
                                        <i className="fa fa-user-plus"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>CRM</p>
                                    </Link>
                                </div>
                            </li>

                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }}
                                title={isSidebarOpen ? '' : 'Customer'}>
                                <div className="main-menu">
                                    <Link to="/customer" onClick={handleLinkClick} className={isActive('/customer') ? 'active-link' : ''}>
                                        <i className="fa fa-users"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Customer</p>
                                    </Link>
                                </div>
                            </li>
                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }} title={isSidebarOpen ? '' : 'Invoice'}>
                                <div className="main-menu">
                                    <Link to="/invoice" onClick={handleLinkClick} className={isActive('/invoice') ? 'active-link' : ''}>
                                        <i className="fa fa-file-invoice"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Invoice</p>
                                    </Link>
                                </div>
                            </li>
                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }} title={isSidebarOpen ? '' : 'Expense'}>
                                <div className="main-menu">
                                    <Link to="/expense" onClick={handleLinkClick} className={isActive('/expense') ? 'active-link' : ''}>
                                        <i className="fa fa-wallet"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Expense</p>
                                    </Link>
                                </div>
                            </li>
                            {/* <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }}>
                                <Link to="/receipt" onClick={handleLinkClick} className={isActive('/receipt') ? 'active-link' : ''}>
                                    <i className="fa fa-file-invoice-dollar"></i>
                                    <p className={isSidebarOpen ? '' : 'closed'}>Receipt</p>
                                </Link>
                            </li> */}



                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }}
                                title={isSidebarOpen ? '' : 'EMI Calculator'}>
                                <div className="main-menu">
                                    <Link to="/loan-emi-calculator" onClick={handleLinkClick} className={isActive('/loan-emi-calculator') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-calculator"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Loan Calculator</p>
                                    </Link>
                                </div>
                            </li>
                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }} title={isSidebarOpen ? '' : 'Feedback'}>
                                <div className="main-menu">
                                    <Link to="/feedback" onClick={handleLinkClick} className={isActive('/feedback') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-comments"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Feedback</p>
                                    </Link>
                                </div>
                            </li>
                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }} title={isSidebarOpen ? '' : 'Offering'}>
                                <div className="main-menu">
                                    <Link to="/offerings" onClick={handleLinkClick} className={isActive('/offerings') ? 'active-link' : ''}>
                                        <i className="fa fa-gift"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Offering</p>
                                    </Link>
                                </div>
                            </li>
                            <li onClick={() => {
                                if (isMobile) toggleSidebar();
                            }} title={isSidebarOpen ? '' : 'Commission'}>
                                <div className="main-menu">
                                    <Link to="/commission" onClick={handleLinkClick} className={isActive('/commission') ? 'active-link' : ''}>
                                        <i className="fa fa-hand-holding-usd"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Commission</p>
                                    </Link>
                                </div>
                            </li>
                            {/* <li title={isSidebarOpen ? '' : 'Schedule'}>
                                <div className="main-menu">
                                    <Link to="/schedule" onClick={handleLinkClick} className={isActive('/schedule') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-calendar-days"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Schedule</p>
                                    </Link>
                                </div>
                            </li> */}
                            {/* <li title={isSidebarOpen ? '' : 'Department'}>
                                <div className="main-menu">
                                    <Link to="/department" onClick={handleLinkClick} className={isActive('/department') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-building"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Department</p>
                                    </Link>
                                </div>
                            </li> */}
                            <li title={isSidebarOpen ? '' : 'Team'}>
                                <div className="main-menu" onClick={() => handleToggleSection(toggleTeam)}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa fa-users"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Team</p>
                                        <i className={`fa fa-chevron-${isTeamOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}></i>
                                    </Link>
                                </div>
                                {isTeamOpen && (
                                    <ul className="submenu">
                                        <li onClick={() => {
                                            if (isMobile) toggleSidebar();
                                        }} >
                                            <Link to="/department" onClick={handleLinkClick} className={isActive('/department') ? 'active-link' : ''}>
                                                <i className="fa fa-sitemap"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Department</p>
                                            </Link>
                                        </li>
                                        <li onClick={() => {
                                            if (isMobile) toggleSidebar();
                                        }} >
                                            <Link to="/team-directory" onClick={handleLinkClick} className={isActive('/team-directory') ? 'active-link' : ''}>
                                                <i className="fa fa-address-book"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Team Directory</p>
                                            </Link>
                                        </li>
                                        <li onClick={() => {
                                            if (isMobile) toggleSidebar();
                                        }} >
                                            <Link to="/team-attendance" onClick={handleLinkClick} className={isActive('/team-attendance') ? 'active-link' : ''}>
                                                <i className="fa fa-clock"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Team Attendance</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            <li>
                                <button className={`toggle-btn toggle-btn-desk ${isSidebarOpen ? 'open' : 'close'}`} onClick={toggleSidebar}>
                                    <i className={`fa ${isSidebarOpen ? 'fa-angle-left' : 'fa-angle-right'}`}></i>
                                </button>
                                <button className={`toggle-btn toggle-btn-mob ${isSidebarOpen ? 'open' : 'close'}`} onClick={toggleSidebar}>
                                    <i className={`fa ${isSidebarOpen ? 'fa-angle-left' : 'fa-angle-left'}`}></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;


{/* <li title={isSidebarOpen ? '' : 'Invoice'}>
                                <div className="main-menu">
                                    <Link to="/invoice" onClick={handleLinkClick} className={isActive('/invoice') ? 'active-link' : ''}>
                                        <i className="fa fa-file-invoice"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Invoice</p>
                                    </Link>
                                </div>
                            </li>
                            <li title={isSidebarOpen ? '' : 'Payments'}>
                                <div className="main-menu" onClick={togglePayments}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa fa-credit-card"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Payments</p>
                                        <i className={`fa fa-chevron-${isPaymentsOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}></i>
                                    </Link>
                                </div>
                                {isPaymentsOpen && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/received-payment" onClick={handleLinkClick} className={isActive('/received-payment') ? 'active-link' : ''}>
                                                <i className="fa fa-money-check-alt"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Received Payment</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/due-payment" onClick={handleLinkClick} className={isActive('/due-payment') ? 'active-link' : ''}>
                                                <i className="fa fa-hand-holding-usd"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Due Payments</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            <li title={isSidebarOpen ? '' : 'Expense'}>
                                <div className="main-menu">
                                    <Link to="/expense" onClick={handleLinkClick} className={isActive('/expense') ? 'active-link' : ''}>
                                        <i className="fa fa-wallet"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Expense</p>
                                    </Link>
                                </div>
                            </li>
                            <li title={isSidebarOpen ? '' : 'Offering'}>
                                <div className="main-menu">
                                    <Link to="/offerings" onClick={handleLinkClick} className={isActive('/offerings') ? 'active-link' : ''}>
                                        <i className="fa fa-gift"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Offering</p>
                                    </Link>
                                </div>
                            </li>
                            <li title={isSidebarOpen ? '' : 'Onboarding'}>
                                <div className="main-menu">
                                    <Link to="/onboarding" onClick={handleLinkClick} className={isActive('/onboarding') ? 'active-link' : ''}>
                                        <i className="fa fa-clipboard-check"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Onboarding</p>
                                    </Link>
                                </div>
                            </li>
                            <li title={isSidebarOpen ? '' : 'User'}>
                                <div className="main-menu" onClick={toggleUser}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa fa-user"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>User</p>
                                        <i className={`fa fa-chevron-${isUserOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}></i>
                                    </Link>
                                </div>
                                {isUserOpen && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/user-records" onClick={handleLinkClick} className={isActive('/user-records') ? 'active-link' : ''}>
                                                <i className="fa fa-clipboard-list"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Records</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/all-users" onClick={handleLinkClick} className={isActive('/all-users') ? 'active-link' : ''}>
                                                <i className="fa fa-users"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>All Users</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            <li title={isSidebarOpen ? '' : 'Users'}>
                                <div className="main-menu" onClick={toggleUserMain}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa fa-user"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Users</p>
                                        <i className={`fa fa-chevron-${isUserOpenMain ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}></i>
                                    </Link>
                                </div>
                                {isUserOpenMain && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/alluser-records" onClick={handleLinkClick} className={isActive('/alluser-records') ? 'active-link' : ''}>
                                                <i className="fa fa-clipboard-list"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>All Records</p>
                                            </Link>
                                        </li>
                                        
                                    </ul>
                                )}
                            </li>
                            <li title={isSidebarOpen ? '' : 'Team'}>
                                <div className="main-menu" onClick={toggleTeam}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa fa-users"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Team</p>
                                        <i
                                            className={`fa fa-chevron-${isTeamOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}
                                        ></i>
                                    </Link>
                                </div>
                                {isTeamOpen && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/team-department" onClick={handleLinkClick} className={isActive('/team-department') ? 'active-link' : ''}>
                                                <i className="fa fa-sitemap"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Department</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/team-directory" onClick={handleLinkClick} className={isActive('/team-directory') ? 'active-link' : ''}>
                                                <i className="fa fa-address-book"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Team Directory</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/team-attendance" onClick={handleLinkClick} className={isActive('/team-attendance') ? 'active-link' : ''}>
                                                <i className="fa fa-clock"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Team Attendance</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>

                            <li title={isSidebarOpen ? '' : 'Plan'}>
                                <div className="main-menu">
                                    <Link to="/plan" onClick={handleLinkClick} className={isActive('/plan') ? 'active-link' : ''}>
                                        <i className="fa fa-chart-line"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Plan</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Gallery'}>
                                <div className="main-menu">
                                    <Link to="/gallery" onClick={handleLinkClick} className={isActive('/gallery') ? 'active-link' : ''}>
                                        <i className="fas fa-images"></i> 
                                        <p className={isSidebarOpen ? '' : 'closed'}>Gallery</p>
                                    </Link>
                                </div>
                            </li>


                            <li title={isSidebarOpen ? '' : 'Updates'}>
                                <div className="main-menu">
                                    <Link to="/updates" onClick={handleLinkClick} className={isActive('/updates') ? 'active-link' : ''}>
                                        <i className="fa fa-sync"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Updates</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Branches'}>
                                <div className="main-menu">
                                    <Link to="/branch" onClick={handleLinkClick} className={isActive('/branch') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-building"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Branches</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Inventory'}>
                                <div className="main-menu" onClick={toggleInventory}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-box"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Inventory</p>
                                        <i
                                            className={`fa-solid fa-chevron-${isInventoryOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}
                                        ></i>
                                    </Link>
                                </div>
                                {isInventoryOpen && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/equipments" onClick={handleLinkClick} className={isActive('/equipments') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-cogs"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Equipments</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/pincode" onClick={handleLinkClick} className={isActive('/pincode') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-map-pin"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Pincode</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/delivery" onClick={handleLinkClick} className={isActive('/delivery') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-truck"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Delivery</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/features" onClick={handleLinkClick} className={isActive('/features') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-cogs"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Features</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/category" onClick={handleLinkClick} className={isActive('/category') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-tags"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Categories</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/coupon" onClick={handleLinkClick} className={isActive('/coupon') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-ticket-alt"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Coupon</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/orders" onClick={handleLinkClick} className={isActive('/orders') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-shopping-cart"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Orders</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            <li title={isSidebarOpen ? '' : 'Class'}>
                                <div className="main-menu" onClick={toggleClass}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-graduation-cap"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Class</p>
                                        <i
                                            className={`fa-solid fa-chevron-${isClassOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}
                                        ></i>
                                    </Link>
                                </div>
                                {isClassOpen && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/age-group" onClick={handleLinkClick} className={isActive('/age-group') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-child"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Age Group</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/class-schedule" onClick={handleLinkClick} className={isActive('/class-schedule') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-calendar-alt"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Class Schedule</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/class-level" onClick={handleLinkClick} className={isActive('/class-level') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-layer-group"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Class Level</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>

                            <li title={isSidebarOpen ? '' : 'Renewals'}>
                                <div className="main-menu">
                                    <Link to="/renewals" onClick={handleLinkClick} className={isActive('/renewals') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-refresh"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Renewals</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Activity'}>
                                <div className="main-menu" onClick={toggleActivity}>
                                    <Link to="#" className={isActive('#') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-clipboard-list"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Activity</p>
                                        <i
                                            className={`fa-solid fa-chevron-${isActivityOpen ? 'up' : 'down'} ${isSidebarOpen ? '' : 'closed'}`}
                                        ></i>
                                    </Link>
                                </div>
                                {isActivityOpen && (
                                    <ul className="submenu">
                                        <li>
                                            <Link to="/activity-log" onClick={handleLinkClick} className={isActive('/activity-log') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-file-alt"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Projects</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/time-log" onClick={handleLinkClick} className={isActive('/time-log') ? 'active-link' : ''}>
                                                <i className="fa-solid fa-clock"></i>
                                                <p className={isSidebarOpen ? '' : 'closed'}>Time log</p>
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>

                            <li title={isSidebarOpen ? '' : 'Salaries'}>
                                <div className="main-menu">
                                    <Link to="/salary" onClick={handleLinkClick} className={isActive('/salary') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-indian-rupee-sign"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Salaries</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Performance'}>
                                <div className="main-menu">
                                    <Link to="/performance" onClick={handleLinkClick} className={isActive('/performance') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-users"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Performance</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Birthday Wish'}>
                                <div className="main-menu">
                                    <Link to="/birthday" onClick={handleLinkClick} className={isActive('/') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-birthday-cake"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Birthday wish</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Whatsapp integration'}>
                                <div className="main-menu">
                                    <Link to="/whatsapp" onClick={handleLinkClick} className={isActive('/whatsapp') ? 'active-link' : ''}>
                                        <i className="fa-brands fa-whatsapp"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Whatsapp</p>
                                    </Link>
                                </div>
                            </li>

                            <li title={isSidebarOpen ? '' : 'Location tracking'}>
                                <div className="main-menu">
                                    <Link to="/location" onClick={handleLinkClick} className={isActive('/location') ? 'active-link' : ''}>
                                        <i className="fa-solid fa-map-marker-alt"></i>
                                        <p className={isSidebarOpen ? '' : 'closed'}>Tracking</p>
                                    </Link>
                                </div>
                            </li> */}